<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">ชำระสินค้า</h1>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table id="dataTable" class="table table-hover table-striped table-bordred">
                  <thead class="thead-light">
                    <tr>
                      <th>No.</th>
                      <th>เลขที่ใบสั่งซื้อ</th>
                      <th>ชื่อลูกค้า</th>
                      <th>ไฟล์รูปภาพ</th>
                      <th>สถานะชำระเงิน</th>
                      <th>วันที่สั่งซื้อ</th>
                      <th>รายละเอียด</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(payment,index) in payments" :key="payment.index">
                      <td>{{++index}}</td>
                      <td>{{payment.order_id}}</td>
                      <td>{{payment.cus_name}} {{payment.cus_lastname}}</td>
                      <td>{{payment.path_file}}</td>
                      <td class="text-center" :class="{}">{{payment.status}}</td>
                      <td>{{payment.created_at}}</td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-success"
                          @click="showOrder(payment)"
                        >
                          <i class="fas fa-search"></i> ดูเพิ่มเติม
                        </button>
                        <!-- v-if="payment.status=='กำลังดำเนินการ'" <span v-else><i class="fas fa-check-circle text-success"></i>completed</span> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal -->
      <div class="modal" id="modalOrder">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">เลขที่ใบสั่งซื้อ {{order_id}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <h5 class="text-bold text-center">ชำระสินค้า</h5>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <label class="input-group-text" for="paymentStatus">สถานะชำระเงิน</label>
                </div>
                <select class="custom-select" v-model="statusPayment" id="paymentStatus">
                  <option disabled>เลือกสถานะ</option>
                  <option value="ชำระเรียบร้อย">ชำระเรียบร้อย</option>
                  <option value="ยกเลิก">ยกเลิก</option>
                </select>
              </div>
              <b>รูปสลิปโอนเงิน:</b><br>
              <div class="d-flex justify-content-center">
                <img :src="getImg()" class="img-fluid rounded">
              </div>
              <div class="row">
                <div class="col-6"><button class="btn btn-success btn-block" @click="confirm()">ยืนยันการโอนเงิน</button></div>
                <div class="col-6"><button class="btn btn-danger btn-block" data-dismiss="modal">ยกเลิก</button></div>
              </div>
              <hr>
              <div id="printOrders">
                <h5 class="text-bold text-center">รายการสั่งซื้อสินค้า</h5>
                  <div class="d-flex justify-content-between">
                  <div>
                    <span class="text-10">วันที่สั่งซื้อ: {{moment(dates).locale('th').format('llll')}}</span>
                  </div>
                  <div>
                    <span class="text-10">เลขที่ใบสั่งซื้อ: {{order_id}}</span>
                  </div>
                </div>
                  <table class="table table-bordered">
                    <tr>
                      <th>ลำดับ</th>
                      <th>รหัสสินค้า</th>
                      <th>ชื่อสินค้า</th>
                      <th>ราคา/หน่วย</th>
                      <th>จำนวนสินค้า</th>
                      <th>จำนวนเงิน</th>
                      <th>จำนวนชิ้น</th>
                      <th>ประเภท</th>
                    </tr>
                    <tr v-for="(order,index) in orderDetails" :key="order.index">
                      <td class="text-center">{{++index}}</td>
                      <td>{{order.product_id}}</td>
                      <td>{{order.product_name}}</td>
                      <td class="text-center">{{order.product_price}}</td>
                      <td class="text-center">{{order.product_unit}} ชิ้น</td>
                      <td class="text-right">{{order.product_real_price | numberFormat }} บาท</td>
                      <td class="text-center">{{order.product_quantity}}</td>
                      <td class="text-center">{{order.product_type}}</td>
                    </tr>
                    <tr class="text-bold">
                      <td colspan="5" class="text-center">รวมเงินทั้งหมด</td>
                      <td class="text-right"><u>{{totalMoney | numberFormat}} บาท</u></td>
                      <td class="text-center">{{listProduct}}</td>
                      <td></td>
                    </tr>
                  </table>
              </div>
              <button v-print="'#printOrders'" class="btn btn-sm btn-primary"><i class="fas fa-print"></i> Print Orders</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import Header from "../components/HeaderBack";
export default {
  components: {
    Header
  },
  data() {
    return {
      pageShow: false,
      payments:{},
      orderDetails:{},
      order_id:'',
      listProduct:0,
      totalMoney:0,
      dates:'',
      imgSlip:'',
      statusImg: false,
      cus_id:'',
      payment_id:'',
      statusPayment:'',
      moment:moment
    };
  },
  beforeCreate() {
    this.axios
      .post(
        "http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin",
        {
          keyid: this.$session.get("keyid"),
          keyserial: this.$session.get("keyserial"),
          keytoken: this.$session.get("keytoken")
        }
      )
      .then(response => {
        if (response.data.checkLogin === 0) {
          this.pageShow = false;
          window.location.href = "/pageLogin";
        } else {
          this.pageShow = true;
        }
      });
  },
  methods: {
    confirm(){
      swal.fire({
        title: 'คุณแน่ใจไหม',
        text: "ยืนยันสถานะการโอนเงิน!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยันการโอนเงิน!'
      }).then((result) => {
        if(this.statusPayment === ''){
          toast.fire({
            type:'error',
            title:'กรุณาเลือกสถานะ'
          })
          return false
        }else{
          if (result.value) {
            this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/confirmStatusPayment', {payment_id: this.payment_id, order_id: this.order_id, cus_id: this.cus_id,status: this.statusPayment})
            .then((res)=>{
              console.log(res.data)
              swal.fire({
                title:res.data.message,
                type:res.data.type
              })
              Fire.$emit('AfterPayment')
              $('#modalOrder').modal('hide')
            })
          }
        }
      })
    },
    dataPayments(){
        this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataPayments')
        .then(res =>{
            this.payments = res.data
            $(document).ready(function() {
                $("#dataTable").DataTable();
            });
        })
    },
    showOrder(order){
      $('#modalOrder').modal('show')
      this.order_id = order.order_id
      this.dates = order.created_at
      this.imgSlip = order.path_file
      this.payment_id = order.payment_id
      this.cus_id = order.cus_id
      this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/detailOrder', {id: order.order_id})
      .then((res)=>{
        this.orderDetails = res.data
        this.total_list()
        this.total_money()
      })
    },
    total_list() {
      this.listProduct = this.orderDetails.length
    },
    total_money(){
      let sum = 0;
      this.totalMoney = this.orderDetails.reduce((key, val) =>{
        return sum += parseInt(val.product_real_price)
      })
    },
    getImg(){
      if(this.imgSlip !='')
      {
        return 'http://pgm01.toonjob.com/2019/BannKlong/image/payments/'+this.imgSlip
      }
    }
  },
  created() {
    this.$Progress.start()
    this.dataPayments()
    Fire.$on('AfterPayment', () =>{
      this.dataPayments()
    })
    this.$Progress.finish()
  },
};
</script>


// WEBPACK FOOTER //
// src/backEnd/Payments.vue